import { Component, OnInit } from "@angular/core";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { UsrCred } from "src/app/models/usrcred";
import { ReadCount } from "./../../models/readCount";
import { VproService } from "./../../service/vpro/vpro.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { sortBy } from 'underscore';
import moment from 'moment';
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
// import { NgCircleProgressModule } from "ng-circle-progress";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

declare var $: any;

@Component({
  selector: 'app-docdashboard',
  templateUrl: './docdashboard.component.html',
  styleUrls: ['./docdashboard.component.css']
})
export class DocdashboardComponent implements OnInit {

  public checkRoleType: (type: any, input: any) => boolean =
    this.utils.checkRoleType;
  public userType: any = Utils.USER_TYPE;
  appcount = new ReadCount();
  // tslint:disable-next-line:no-inferrable-types
  submitted: boolean = false;
  dcred = new DashCred();
  MainCtrl = "first";
  rcounts: any;
  // apnames: any;
  chkdet: any;
  user = new UsrCred();
  data: Number;
  consultChecked: boolean = false;
  pat_users = [];
  // dashboarddata: import("/home/syed/soopdoc/src/app/models/physician").Physician;

  name1: any;
  name2: any;
  AppointmentStatus = Utils.APPOINTMENT_STATUS;
  noAppointments: boolean = false;
  Appointments: any;
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  apptlen: any;
  apptlen_adm: any;
  acheckin: any[];
  isCheckInLoading: boolean;
  checkin_count: number;
  adm_checkin_count: number;
  form: UntypedFormGroup;
  dashboarddata: any;
  todaysOnlineAppointmentCount: any;
  todaysInpersonAppointmentCount: any;
  todaysInpersonAppointmentallCount: any;
  todaysOnlineAppointmentallCount: any;
  phyfname: any;
  phylname: string;
  a_dashboardvalues: any;
  dashboardvalues1: any;
  physician: any
  currentDate = Utils.maxDate;
  weightage = 0;
  msg: string = "";
  uid: number;
  color = '#FF1200';
  searchValue: string = '';
  //msg: any;
  //weightage: any ;

  constructor(
    private route: ActivatedRoute,
    private service: VproService,
    private _formBuilder: UntypedFormBuilder,
    private utils: Utils,
    private spinner: NgxSpinnerService,
    private trimFormValuesService: TrimFormValuesService,
  ) { }

  ngOnInit(): void {
    this.loadPhysician();
    this.name1 = localStorage.getItem("first_name");
    this.name2 = localStorage.getItem("last_name");

    //this.weightagee = this.weightage;
    this.uid = parseInt(localStorage.getItem("uid"));
    this.form = this._formBuilder.group({
      name: [null],
    });

    this.getdashboardvalues();
    this.getadmindashboardvalues();    //this.apptcount();
    this.dashboardvalues();
    this.apptcount_adm();
    this.chkincount();
    this.chkincount_adm();
    this.getAppointmentCount();
    this.data = JSON.parse(localStorage.getItem("LogUsrTyp"));

    this.searchuser();


    this.getCheckedInPats(localStorage.getItem("LogUsr"));

    this.service
      .getApcount(this.dcred)
      .subscribe((data) => (this.rcounts = data));

    // this.service.getApNames(this.dcred)
    // .subscribe(data => this.apnames = data);

    this.MainCtrl = "first";
    // this.service.getPatients()
    //   .subscribe(data => this.pdata = data);
    this.getConsultNow();

    this.service.consultNowUpdate.subscribe((data: any) => {
      console.log("Inside subscription of consult now", data);
      if (data) this.consultChecked = data.consultNow;
    });


  }


  getAppointmentCount(type: string = '', pg: number = 1) {

    let data_online = {
      org_code: localStorage.getItem('orgcode')
    }
    data_online['type'] = 'online';
    data_online['apdate'] = moment().format("YYYY-M-DD");

    console.log("getOnlineAppointmentCount:Search VALUES", data_online);

    this.spinner.show();
    this.service.getCheckedInPats(data_online, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      //this.appointments = res['data'];
      this.todaysOnlineAppointmentCount = res['totalCount'];
      console.log("getOnlineAppointmentCount:count", this.todaysOnlineAppointmentCount);
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    })

    let data_inperson = {
      org_code: localStorage.getItem('orgcode')
    }
    data_inperson['type'] = 'in_person';
    data_inperson['apdate'] = moment().format("YYYY-M-DD");

    console.log("getInpersonAppointmentCount:Search VALUES", data_inperson);

    this.spinner.show();
    this.service.getCheckedInPats(data_inperson, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      //this.appointments = res['data'];
      this.todaysInpersonAppointmentCount = res['totalCount'];
      console.log("getInpersonAppointmentCount:count", this.todaysInpersonAppointmentCount);
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    })

    let data_inperson_all = {
      org_code: localStorage.getItem('orgcode')
    }
    data_inperson_all['type'] = 'in_person';


    console.log("data_inperson_all:Search VALUES", data_inperson);

    this.spinner.show();
    this.service.getCheckedInPats(data_inperson_all, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      //this.appointments = res['data'];
      this.todaysInpersonAppointmentallCount = res['totalCount'];
      console.log("getInpersonAppointmentCount:count", this.todaysInpersonAppointmentallCount);
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    })

    let data_online_all = {
      org_code: localStorage.getItem('orgcode')
    }
    data_online_all['type'] = 'online';


    console.log("data_online_all:Search VALUES", data_inperson);

    this.spinner.show();
    this.service.getCheckedInPats(data_online_all, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      //this.appointments = res['data'];
      this.todaysOnlineAppointmentallCount = res['totalCount'];
      console.log("getInpersonAppointmentCount:count", this.todaysOnlineAppointmentallCount);
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    })
  }
  clearSearch() {
    this.searchValue = '';
  }
  loadPhysician() {


    this.service.getPhysicianById(localStorage.getItem("uid"), '?fields=physician_bank_details').subscribe(
      (responsee) => {
        this.physician = responsee
        if (!this.physician.physician_bank_details)
          this.msg += '\n' + "Provide Bank account details";
        else
          this.weightage += 10;
      })


    this.service.getPhysicianById(localStorage.getItem("uid"), '?fields=physician_illness').subscribe(
      (responsee) => {
        if (responsee['physician_illness'].length > 0) {
          this.weightage += 10;
        }
        else
          this.msg += '\n' + "Provide info on Illnesses treated";
      })


    this.service.getPhysicianById(localStorage.getItem("uid"), '?fields=physician_dashboard').subscribe(
      (response) => {

        this.dashboarddata = response.physician_dashboard;
        this.phyfname = response.first_name;
        this.phylname = response.last_name;

        if (response) {
          this.physician = response;

          console.log("Physician RESPONSE", this.physician);

          if (!this.physician.verified)
            this.msg += '\n' + "Verify Your profile";
          else
            this.weightage += 15;

          if (!this.physician.title)
            this.msg += '\n' + "Provide Title for your profile";
          else
            this.weightage += 2;

          let str = this.physician.ppurl;
          let flag = str.includes("default_doctor.png");
          if (flag)
            this.msg += '\n' + "Add profile picture";
          else
            this.weightage += 2;

          if (!this.physician.dob)
            this.msg += '\n' + "Provide Date Of Birth";
          else
            this.weightage += 2;


          if (!this.physician.email_id2)
            this.msg += '\n' + "Provide Public email address";
          else
            this.weightage += 2;

          if (!this.physician.contact_no2)
            this.msg += '\n' + "Provide Public contact_no";
          else
            this.weightage += 2;

          if ((!this.physician.address_1 && !this.physician.address_2))
            this.msg += '\n' + "Provide address Details";
          else
            this.weightage += 2;

          if (!this.physician.city)
            this.msg += '\n' + "Provide City info";
          else
            this.weightage += 2;

          if (!this.physician.state)
            this.msg += '\n' + "Provide State info";
          else
            this.weightage += 2;

          if (!this.physician.zip)
            this.msg += '\n' + "Provide zip code info";
          else
            this.weightage += 1;

          if (!this.physician.additional_info)
            this.msg += '\n' + "Provide Additional info";
          else
            this.weightage += 1;

          console.log("this.physician.physician_consultfee[0].fee");

          console.log("this.physician.physician_consultfee[0].fee", this.physician.physician_consultfee);
          if (this.physician.physician_consultfee == null || !this.physician.physician_consultfee[0].fee)
            this.msg += '\n' + "Provide Consultation Fee amount";
          else
            this.weightage += 5;


          if (this.physician.physician_consultfee == null || !this.physician.physician_consultfee[0].followup_fee)
            this.msg += '\n' + "Provide follow-up Fee amount";
          else
            this.weightage += 5;

          if (this.physician.physician_qualification == null || !this.physician.physician_qualification[0].r_no)
            this.msg += '\n' + "Provide Medical Registration No";
          else
            this.weightage += 5;

          if (this.physician.physician_qualification == null || !this.physician.physician_qualification[0].smc)
            this.msg += '\n' + "Provide State Medical Council Details";
          else
            this.weightage += 2;

          if (this.physician.physician_qualification == null || !this.physician.physician_qualification[0].qualification)
            this.msg += '\n' + "Provide Education qualification details";
          else
            this.weightage += 5;

          if (!this.physician.physician_experience)
            this.msg += '\n' + "Provide Work Experience Details";
          else
            this.weightage += 10;

          if (!this.physician.physician_education)
            this.msg += '\n' + "Provide Education Details";
          else
            this.weightage += 10;

          if (!this.physician.physician_speciality)
            this.msg += '\n' + "Provide speciality Details";
          else
            this.weightage += 5;
        }

        console.log("weightage:::", this.weightage)
        if (this.weightage == 100)
          this.color = "#4BCF00";
        else if (this.weightage >= 70 && this.weightage < 99)
          this.color = "#4D97E2";
        else if (this.weightage >= 50 && this.weightage < 70)
          this.color = "#FFC300";
        else if (this.weightage < 50 && this.weightage > 0)
          this.color = "#FF1200";
      })
  }

  getCheckedInPats(usereid: string) {
    try {
      this.service.getCheckedInPats().subscribe(
        (res) => {
          this.chkdet = res;
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
  getApcount() {
    try {
      this.service.getApcount(this.dcred).subscribe(
        (res) => {
          this.rcounts = res;
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  checkValue(event: any) {
    this.setConsultNow();
  }

  getConsultNow() {
    this.spinner.show();
    this.service
      .getConsultNow(JSON.parse(localStorage.getItem("uid")))
      .subscribe(
        (res) => {
          this.spinner.hide();
          console.log("consultNow", res);
          this.consultChecked = res.consult_now;
        },
        (err) => {
          this.spinner.hide();
          console.log(err);
          let message = "Something wrong. Please try again later.";
          if (
            err &&
            err.error &&
            err.error.error &&
            err.error.error.length > 0
          ) {
            for (let e of err.error.error) {
              this.showToast("error", e);
            }
            return;
          }
          this.showToast("error", message);
        }
      );
  }


  searchuser() {

    this.pat_users = [];

    let data = {
      name: null,
      // name: this.form.value.name,
      org_code: localStorage.getItem("orgcode")
    }
    this.trimFormValuesService.trimValues(data);
    this.service.fetchPatients(data).subscribe(
      (response) => {

        if (response && response.length > 0) {
          this.pat_users = response;
          this.pat_users = sortBy(this.pat_users, 'first_name'); // Data Sorter via underscore.js
          console.log("patients", this.pat_users)
        }
      },
      (error) => {

      }
    );

  }

  search() {

    this.pat_users = [];

    let data = {
      //name: null,
      name: this.form.value.name,
      org_code: localStorage.getItem("orgcode")
    }
    this.trimFormValuesService.trimValues(data);
    this.spinner.show();

    this.service.fetchPatients(data).subscribe(
      (response) => {
        this.spinner.hide();
        if (response && response.length > 0) {
          this.pat_users = response;
          this.pat_users = sortBy(this.pat_users, 'first_name'); // Data Sorter via underscore.js
          console.log("patients", this.pat_users)
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );

  }

  setConsultNow() {
    this.spinner.show();
    this.service
      .setConsultNow(JSON.parse(localStorage.getItem("uid")), {
        consult_now: this.consultChecked,
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.showToast("success", res);
        },
        (err) => {
          this.spinner.hide();
          console.log(err);
          let message = "Something wrong. Please try again later.";
          if (
            err &&
            err.error &&
            err.error.message &&
            err.error.message.message
          ) {
            message = err.error.message.message;
          }
          this.consultChecked = !this.consultChecked;
          this.showToast("error", message);
        }
      );
  }

  handleApiRes(conflicts, success) {
    for (let s of success) {
      this.showToast("success", s);
    }
    for (let e of conflicts) {
      this.showToast("error", e);
    }
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  apptcount() {

    let datass = {
      org_code: localStorage.getItem('orgcode'),
      status: [this.AppointmentStatus.APPROVAL_REQUESTED],
      from: moment().format("YYYY-M-DD"),
      to: moment().format("YYYY-M-DD"),
      doc_name: localStorage.getItem("first_name"),
    }

    console.log("datasdatasdatas", datass);


    this.service.displayAppoint(datass, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      this.Appointments = res['data'];
      // this.Appointments = sortBy(this.Appointmentss, 'apdate'); // Data Sorter via underscore.js
      this.apptlen = this.Appointments.length;

      console.log("APPOINTTAPPOINTT", this.apptlen);

      this.collectionSize = res['totalCount'];
      if (this.Appointments && this.Appointments.length) {
        // this.Appointments = sortBy(this.Appointments, 'aptime'); // Data Sorter via underscore.js
        // this.Appointments = sortBy(this.Appointments, 'apdate'); // Data Sorter via underscore.js
        this.noAppointments = false;
      }
      else {
        this.noAppointments = true;
        this.page = 1;
        this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
      }
    }, err => {
      this.spinner.hide();
      console.log(err);
    })
  }
  apptcount_adm() {

    let data = {
      org_code: localStorage.getItem('orgcode'),
      status: [this.AppointmentStatus.APPROVAL_REQUESTED],
      from: moment().format("YYYY-M-DD"),
      to: moment().format("YYYY-M-DD"),

    }

    console.log("datasdatasdatas", data);




    this.service.displayAppoint(data, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      // this.spinner.hide();
      this.Appointments = res['data'];
      // this.Appointments = sortBy(this.Appointmentss, 'apdate'); // Data Sorter via underscore.js
      this.apptlen_adm = this.Appointments.length;
      console.log("APPOINTTAPPOINTT", this.apptlen);
      this.collectionSize = res['totalCount'];
      if (this.Appointments && this.Appointments.length) {
        // this.Appointments = sortBy(this.Appointments, 'aptime'); // Data Sorter via underscore.js
        // this.Appointments = sortBy(this.Appointments, 'apdate'); // Data Sorter via underscore.js
        this.noAppointments = false;
      }
      else {
        this.noAppointments = true;
        this.page = 1;
        this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
      }
    }, err => {
      //this.spinner.hide();
      console.log(err);
    })
  }

  chkincount() {

    //console.log("console the values", values)

    try {

      this.isCheckInLoading = true;
      let data = {

        org_code: localStorage.getItem('orgcode'),
        apttype: Utils.OFFLINE_APPOINTMENTS,
        apdate: moment().format("YYYY-M-DD"),
        drid: parseInt(localStorage.getItem("uid")),

      }
      // let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

      // if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
      //   data["drid"] = parseInt(localStorage.getItem("uid"));
      // }

      console.log("datadatadatadatadata", data);

      this.service.displayAppoint(data).subscribe(
        (appointments: any[]) => {
          console.log("chkincount", appointments.length);
          this.acheckin = appointments;
          this.checkin_count = appointments.length;

          // if (data.doc_name) {
          //   this.acheckin = this.acheckin.filter(docname =>

          //     docname.physician_first_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     || docname.physician_last_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     //   docname.physician_first_name == input.doc_name

          //     || docname.physician_first_name.toString().concat(" ", docname.physician_last_name.toString()).toLowerCase().includes(data.doc_name.toLowerCase()))


          // }
          // this.acheckin = this.acheckin.filter(list => list.dob != null)
          //this.acheckin = sortBy(this.acheckin, 'aptime'); // Data Sorter via underscore.js
          // this.acheckin = sortBy(this.acheckin, 'apdate'); // Data Sorter via underscore.js




          // let norecmsg = (this.acheckin && this.acheckin.length == 0)

          //   ? this.innerHtml = "<h3 align='center'>No appointments</h3>" : this.innerHtml = "";

          // this.isCheckInLoading = false;
        },
        (error) => {
          console.log(error);
        }
      );

    } catch (excep) {
      console.log(excep);
    }
  }

  chkincount_adm() {

    //console.log("console the values", values)

    try {

      this.isCheckInLoading = true;
      let data = {

        org_code: localStorage.getItem('orgcode'),
        apttype: Utils.OFFLINE_APPOINTMENTS,
        apdate: moment().format("YYYY-M-DD"),


      }
      // let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

      // if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
      //   data["drid"] = parseInt(localStorage.getItem("uid"));
      // }

      //console.log("chkincount_adm", data);

      this.service.displayAppoint(data).subscribe(
        (appointments: any[]) => {
          console.log("chkincount_adm", appointments.length);
          this.acheckin = appointments;
          this.adm_checkin_count = appointments.length;

          // if (data.doc_name) {
          //   this.acheckin = this.acheckin.filter(docname =>

          //     docname.physician_first_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     || docname.physician_last_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     //   docname.physician_first_name == input.doc_name

          //     || docname.physician_first_name.toString().concat(" ", docname.physician_last_name.toString()).toLowerCase().includes(data.doc_name.toLowerCase()))


          // }
          // this.acheckin = this.acheckin.filter(list => list.dob != null)
          //this.acheckin = sortBy(this.acheckin, 'aptime'); // Data Sorter via underscore.js
          // this.acheckin = sortBy(this.acheckin, 'apdate'); // Data Sorter via underscore.js




          // let norecmsg = (this.acheckin && this.acheckin.length == 0)

          //   ? this.innerHtml = "<h3 align='center'>No appointments</h3>" : this.innerHtml = "";

          // this.isCheckInLoading = false;
        },
        (error) => {
          console.log(error);
        }
      );

    } catch (excep) {
      console.log(excep);
    }
  }

  dashboardvalues() {

    try {

      let orgcode = localStorage.getItem("orgcode");
      let date = this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day;


      this.service.admindashboardvalues({ org_code: orgcode, date: date }).subscribe(
        (res) => {
          let lmtotal = 0;
          let lmfeetotal = 0;
          let cmtotal = 0;
          let cmfeetotal = 0;
          // this.payloadInvoce = res['THIS_MONTH_EARNING'];
          // this.payloadInvocee = res['LAST_MONTH_EARNING'];
          // this.cmaptonline = res['THIS_MONTH_APPOINTMENT_ONLINE'];
          // this.lmaptonline = res['LAST_MONTH_APPOINTMENT'];

          console.log("getdashboardvalues", res);


          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    } catch (excep) {
      console.log(excep);
      this.spinner.hide();
    }
  }

  getdashboardvalues() {

    try {

      //let orgcode = localStorage.getItem("orgcode");

      let date = this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day;

      let drid = parseInt(localStorage.getItem("uid"));

      this.service.admindashboardvalues({ drid: drid, date: date }).subscribe(
        (res) => {
          let lmtotal = 0;
          let lmfeetotal = 0;
          let cmtotal = 0;
          let cmfeetotal = 0;
          // this.payloadInvoce = res['THIS_MONTH_EARNING'];
          // this.payloadInvocee = res['LAST_MONTH_EARNING'];
          // this.cmaptonline = res['THIS_MONTH_APPOINTMENT_ONLINE'];
          // this.lmaptonline = res['LAST_MONTH_APPOINTMENT'];

          this.dashboardvalues1 = res;

          console.log("getdashboardvalues", this.dashboardvalues1);
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    } catch (excep) {
      console.log(excep);
      this.spinner.hide();
    }
  }

  getadmindashboardvalues() {

    try {

      let orgcode = localStorage.getItem("orgcode");
      let date = this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day;


      this.service.admindashboardvalues({ org_code: orgcode, date: date }).subscribe(
        (res) => {
          let lmtotal = 0;
          let lmfeetotal = 0;
          let cmtotal = 0;
          let cmfeetotal = 0;
          // this.payloadInvoce = res['THIS_MONTH_EARNING'];
          // this.payloadInvocee = res['LAST_MONTH_EARNING'];
          // this.cmaptonline = res['THIS_MONTH_APPOINTMENT_ONLINE'];
          // this.lmaptonline = res['LAST_MONTH_APPOINTMENT'];

          this.a_dashboardvalues = res;

          console.log("getdashboardvalues", this.a_dashboardvalues);
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    } catch (excep) {
      console.log(excep);
      this.spinner.hide();
    }
  }



  reload() {
    location.reload();
  }

}
